import { useTranslation } from "react-i18next";

const BasicTable = ({ data = [], headers = [] }) => {
  const { t } = useTranslation();
  return (
    <table className="table">
      <thead>
        <tr>
          {headers?.map((header) => (
            <th scope="col" key={header}>
              {t("eidBasmati." + header)}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data?.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {headers.map((header) => (
              <td key={header}>{row[header]}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default BasicTable;
